import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManualUpdateRoutingModule } from './manual-update-routing.module';
import { AddManualUpdateComponent } from './add-manual-update/add-manual-update.component';
import { AddSingleManualUpdateComponent } from './add-single-manual-update/add-single-manual-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { BulkImportManualUpdateComponent } from './bulk-import-manual-update/bulk-import-manual-update.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';


@NgModule({
  declarations: [AddManualUpdateComponent, AddSingleManualUpdateComponent, BulkImportManualUpdateComponent],
  imports: [
    CommonModule,
    //ManualUpdateRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    RouterModule.forChild(ManualUpdateRoutingModule),
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    DistributedUIModule,
    MatChipsModule,
    BsDropdownModule,
    SharedUIModule,
    NgxPowerBiModule,
    TabsModule.forRoot()
  ],
  entryComponents: [
    AddManualUpdateComponent,
    AddSingleManualUpdateComponent,
    BulkImportManualUpdateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  // exports: [
  //    ImportExternalUpdateComponent,
  //  ],
})

export class ManualUpdateModule { }
